type JackpotOffer = 'bonanza' | 'overdrive' | 'rapidfire';

type JackpotVariant = 'default' | 'sticky';

type JackpotType = {
  label: string;
  value: number;
  previousValue: number;
  refreshInterval: number;
  highlight: boolean;
  icon: React.ReactNode | undefined;
  variant: JackpotVariant;
};

type JackpotBonanzaJackpots = 'grand' | 'mega' | 'major' | 'mini';
type JackpotBonanzaApiResponse = {
  jackpots: Record<JackpotBonanzaJackpots, number>;
  games: string[];
};

/** Blueprint Rapid Fire tier codes from feed `jackpotName`. */
type JackpotRapidFireTierName = 'rapidhit1' | 'rapidhit2' | 'rapidhit3' | 'rapidhit4' | 'rapidhit5';

/** Desktop visual order: Master, Major, Mega King (highlight), Minor, Mini. */
const RAPID_FIRE_DISPLAY_ORDER: readonly JackpotRapidFireTierName[] = ['rapidhit2', 'rapidhit3', 'rapidhit1', 'rapidhit4', 'rapidhit5'];

type JackpotRapidFireApiEntry = {
  jackpotName: string;
  amount: number;
  games?: string[];
  previousWinAmount?: number;
  previousWinDate?: string;
};

type JackpotRapidFireProviderResponse = {
  provider: string;
  jackpots: JackpotRapidFireApiEntry[];
};

export { RAPID_FIRE_DISPLAY_ORDER };
export type {
  JackpotBonanzaApiResponse,
  JackpotBonanzaJackpots,
  JackpotOffer,
  JackpotRapidFireApiEntry,
  JackpotRapidFireProviderResponse,
  JackpotRapidFireTierName,
  JackpotType,
  JackpotVariant,
};
